import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

import { ToastProps, ToastContextData, ToastProviderProps } from './interfaces';

import ToastWrapper from './ToastWrapper';

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  /*
   * Hooks
   */
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const id = useRef(0);

  //
  const addToast = useCallback((newToast: ToastProps) => {
    const updatedToast = { ...newToast };

    id.current += 1;

    updatedToast.id = id.current;

    setToasts((prevToasts) => [...prevToasts, updatedToast]);
  }, []);

  //
  const removeToast = useCallback((toastId: number) => {
    setToasts((prevToasts) => prevToasts.filter((currentToast) => currentToast.id !== toastId));
  }, []);

  const contextValue = useMemo(() => ({ addToast, removeToast }), [addToast, removeToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}

      <ToastWrapper toasts={toasts} />
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextData => {
  /*
   * Hooks
   */
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast can only be used inside a ToastProvider!');
  }

  return context;
};
